import React from 'react';

import { Box, Button, ButtonGroup, Tooltip } from '@mui/material';

import { KanbanItem } from '../../@types/State';
import { effects } from '../../Effects';

interface Props {
  isDuration: boolean;
  isWarPlan: boolean;
  addOp?: (op: string, selected: KanbanItem | null) => void;
  selected: KanbanItem | null;
  selectedOps?: string[];
  addColumnOp?: (op: string) => void;
}

const RenderOps: React.FC<Props> = ({
  isDuration,
  isWarPlan,
  addOp,
  selected,
  selectedOps,
  addColumnOp,
}) => {
  const alreadyAdded = selectedOps ?? [];
  const list = Object.entries(effects).filter(
    ([key, value]) =>
      value.isBad === isWarPlan &&
      value.isRequestable &&
      value.isDuration == isDuration &&
      !alreadyAdded.includes(key)
  );
  return (
    <Box
      sx={{
        paddingRight: 1,
        maxHeight: '90vh',
        overflowY: 'scroll',
        overflow: 'auto',
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': {
          width: '0.4em',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#555',
        },
      }}
    >
      <ButtonGroup orientation='vertical'>
        {list.map(([key, value]) => (
          <Tooltip title={key} key={key} arrow>
            <Button
              variant='outlined'
              onClick={(e) => {
                addOp && addOp(key, selected);
                addColumnOp && addColumnOp(key);
              }}
              size='small'
              sx={{ textTransform: 'unset' }}
              startIcon={value.svg}
            >
              {value.shortName}
            </Button>
          </Tooltip>
        ))}
      </ButtonGroup>
    </Box>
  );
};
export default RenderOps;
